import React, { useEffect, useState } from 'react';


import slide1 from '../assets/img/slide1.jpg';

import staricon from '../assets/img/starbtn.png';
import staricon1 from '../assets/img/r_arrow.png';
import iconstrt from '../assets/img/iconstartt.png';
import Bhavnaimg from '../assets/img/imagebhavna.png';
import Trans from '../assets/img/bhav.gif';
import Oneone from '../assets/img/oneone.png';
import Oneone1 from '../assets/img/imgg.jpg';
import Testibg from '../assets/img/Collection.jpg';
import Testiimg1 from '../assets/img/courses/testi1.jpg';
import Testiimg2 from '../assets/img/courses/testi2.jpg';
import Testiimg3 from '../assets/img/courses/testi3.jpg';
import Testiimg4 from '../assets/img/courses/testi4.jpg';
import Playbtn from "../assets/img/courses/play.png";
import CommonModal from "../components/CommonModal";

import SeoHelmet from "../components/SeoHelmet";
import blogo from "../assets/img/2logo.png";
import Whatsaap from "../assets/img/whatsapp.png";
import Whatsaap1 from "../assets/img/whatapp_text.png";


const HomePage = () => {
 
  const [activeVideo, setActiveVideo] = useState(null);

  const handleOpenModal = (videoSrc) => {
    setActiveVideo(videoSrc); // Set the active video source
  };

  const handleCloseModal = () => {
    setActiveVideo(null); // Clear the active video source
  };
 
    useEffect(() => {
       
        if (window.Swiper) {
          
          const swiperQuiz = new window.Swiper(".animeslide", {
            effect: "fade",
            loop: true,
            // autoplay: 5000,
            // speed: 900,
            // autoplay: {
            //   delay: 2800,
            // },
            centeredSlides: true,
            pagination: {
              el: ".animeslide-pagination",
              clickable: true,
            },
            navigation: {
              nextEl: ".animeslide-button-next",
              prevEl: ".animeslide-button-prev",
            },
            
            keyboard: {
              enabled: true,
              onlyInViewport: false,
            },
            runCallbacksOnInit: true,
          });
    
          
          const swiper = new window.Swiper(".instpostslide", {
            loop: true,
            slidesPerView: 1,
            navigation: {
              nextEl: ".testi-button-next",
              prevEl: ".testi-button-prev",
            },
            breakpoints: {
              768: {
                slidesPerView: 4, 
                spaceBetween: 30,
                navigation: {
                  nextEl: ".testi-button-next",
                  prevEl: ".testi-button-prev",
                },
              },
              // You can add more breakpoints if needed
            },
          
          });
        }

       


      }, []); 
    
  return (

    <>
 <SeoHelmet />

 
<CommonModal id="staticBackdrop" />


    <section className='banner_outer'>
      <div className="swiper animeslide">
        <div className="swiper-wrapper">
          <div className="swiper-slide animeslide-slide slide4" style={{ backgroundImage: `url(${slide1})` }}>
            <div className="container">
              <div className="content-slide">
                <div data-animate="bottom" className="animeslide-heading">
                   <a className='banner_logo' href="#"><img src={blogo} ></img></a>
                  <h2>Bhavana Singh </h2>
                   {/* <h3>Transform with Bhavana Next Online Batch 27jan-31th jan</h3>  */}
                </div>
                <div data-animate="bottom" className="animeslide-desc">
                  <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><img className='contact_icon' src={staricon} ></img><img className='contact_icon1' src={staricon1} ></img>CONNECT WITH US</a>
                  
                </div>
               
              </div>
            </div>
          </div>
          <div className="swiper-slide animeslide-slide slide1" style={{ backgroundImage: `url(${slide1})` }}>
            <div className="container">
              <div className="content-slide">
                <div data-animate="bottom" className="animeslide-heading">
                   <a className='banner_logo' href="#"><img src={blogo} ></img></a>
                  <h2>Bhavana Singh </h2>
                  {/* <h3>Stylist | Designer | Personality Transformation Coach </h3> */}
                </div>
                <div data-animate="bottom" className="animeslide-desc">
                  <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><img src={staricon} ></img>CONNECT WITH US</a>
                </div>
                
              </div>
            </div>
          </div> 
          <div className="swiper-slide animeslide-slide slide2" style={{ backgroundImage: `url(${slide1})` }}>
            <div className="container">
              <div className="content-slide">
                <div data-animate="bottom" className="animeslide-heading">
                   <a className='banner_logo' href="#"><img src={blogo} ></img></a>
                  <h2>Bhavana Singh </h2>
                  {/* <h3>Stylist | Designer | Personality Transformation Coach </h3> */}
                </div>
                <div data-animate="bottom" className="animeslide-desc">
                  <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><img src={staricon} ></img>CONNECT WITH US</a>
                </div>
                
              </div>
            </div>
          </div>
          <div className="swiper-slide animeslide-slide slide3" style={{ backgroundImage: `url(${slide1})` }}>
            <div className="container">
              <div className="content-slide">
                <div data-animate="bottom" className="animeslide-heading">
                   <a className='banner_logo' href="#"><img src={blogo} ></img></a>
                  <h2>Bhavana Singh </h2>
                  {/* <h3>Stylist | Designer | Personality Transformation Coach </h3> */}
                </div>
                <div data-animate="bottom" className="animeslide-desc">
                  <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><img src={staricon} ></img>CONNECT WITH US</a>
                </div>
                
              </div>
            </div>
          </div>
        </div>
        {/* <div className="flex animeslide-bottom">
          <div className="animeslide-pagination swiper-pagination"></div>
        </div> */}
      </div>
    </section>
    <section className='week_buss'>
       <div className="container">
          <div className='bussinpartcol'>
            <div className='busprogram'>
              <img src={iconstrt}></img>
              <h2><a href='/two-week-transformation'>2 Week<br></br> Offline Course</a></h2>
            </div>
            <div className='busprogram'>
              <img src={iconstrt}></img>
              <h2><a href='/one-week-transformation'>1 Week<br></br> Offline Course</a></h2>
            </div>
            <div className='busprogram'>
              <img src={iconstrt}></img>
              <h2><a href='/five-day-transformation'>5 Day Online<br></br> Course</a></h2>
            </div>
          </div>
       </div>
    </section>
    <section className="about_part">
      <div className="container">
          <div className='mbr_row'>
              <div className="about_image">
                  <img src={Bhavnaimg} alt="Bhavana Singh" />
              </div>
              <div className="about_content">
                <span className="about_tag">ABOUT</span>
                <h2 className='titlebhav'>Bhavana Singh</h2>
                <p>Bhavana Singh is a Personality & Image Transformation Coach who has transformed 1000+ lives, working with <br></br>both men and women to build confidence and self-belief from within. Beyond being a well-known stylist and TEDx speaker, she focuses on how people think, speak, and carry themselves. Through personality coaching, body language training, grooming, public speaking, and pageant guidance, she helps individuals develop a strong, impactful presence.</p>
                <a href="/about-us" className="about_btn">
                  <img src={iconstrt} alt="" />
                  KNOW MORE
                </a>
              </div>
          </div>
      </div>
    </section>
     <section className="transform_part">
      <div className="container">
        <div className='mbr_mission'>
          <div className='mbr_row'>
              
              <div className="about_content">
                <span className="about_tag">transform with</span>
                <h2 className='titlebhav'>Bhavana Singh</h2>
                <span className="about_tag">Personality, Confidence & Style Transformation Courses</span>
                <div className='trans_prtt'>
                  <h4>Intensive Personality & Career Transformation
                    2 weeks offline course</h4>
                  <p>This course will bring a deep personality and career shift for anyone ready to move ahead in life. With Bhavana guiding you closely, you understand your behaviour, refine your style, strengthen communication, and  learn to own every space you walk into.</p>
                </div>
                <div className='trans_prtt'>
                  <h4>Personality Enhancement Masterclass
                1 week offline course</h4>
                  <p>This one-week course helps you reset how you look, feel, and show up in everyday life. With Bhavana’s close guidance, you build confidence, body language, grooming, and mindset—so you step out feeling calm, polished, and fully comfortable being seen.</p>
                </div>
                <div className='trans_prtt'>
                  <h4>Live Online WorkShop
                    5days online course</h4>
                  <p>This five-day live online course offers 4-hour interactive sessions each day, guided closely by Bhavana from the comfort of your home. You’ll learn personal style, confident communication, and body language in a clear, supportive environment—helping you show up stronger, calmer, and more confident in everyday life.</p>
                </div>
                <a href="/personality-development-courses" className="terrs_btn">
                  <img src={iconstrt} alt="" />
                  KNOW MORE
                </a>
              </div>
              <div className="about_imagee">
                  <img src={Trans} alt="Bhavana Singh" />
              </div>
          </div>
           
          <div className='missionmen'>
            <p>“My mission is to be the mentor I yearned for but never had, guiding others to break free from self-doubt and realize their full potential.”</p>
            <span>— Bhavana Singh</span>
          </div>
          <div className="about_image_mobile">
                <img src={Trans} alt="Bhavana Singh" />
              </div>
          </div>
      </div>
    </section>

    <section className="oneone_part">
      <div className="container">
          <div className='mbr_roww'>
              <div className="about_images">
                <img className='one' src={Oneone} alt="Bhavana Singh" />
                <img className='ones' src={Oneone1} alt="Bhavana Singh" />

              </div>
              <div className="about_content">
                <span className="about_tag">One-On-One</span>
                <h2 className='titlebhav'>Personal Transformation </h2>
                <span className="about_tag">For those wanting things to be personal, private, and up close</span>
                <div className='trans_prttt'>
                  <p>This fully personalised one-on-one program gives you<br></br> private, hands-on guidance from Bhavana to build<br></br> confidence, grooming, style, and a powerful personal<br></br> image. Everything is tailored to you, with complete<br></br> confidentiality—your identity, sessions, and progress<br></br> remain strictly private. </p>
                </div>
               <div className='btngroup'>
                 <a href="/one-on-one-transformation" className="terrs_btn">
                  <img src={iconstrt} alt="" />
                  KNOW MORE
                </a>
                 <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop" className="terrs_btn">
                  <img src={iconstrt} alt="" />
                  ENROLL NOW
                </a>
               </div>
              </div>
             
          </div>
         
      </div>
    </section>
    <section className='personal'>
      <div className="container">
           <img className='testi' src={Bhavnaimg}></img>
      </div>
    </section>
    <section className='testimonal_part' style={{ backgroundImage: `url(${Testibg})` }}>
        <div className="container">
          
            <h4>testimonials</h4>
            <h2>Incredible Transformation Stories<br></br>that Will Shock You</h2>
            <p>Real stories and honest experiences from women who have trained with<br></br> Bhavana. See how confidence, style, and self-belief have changed their lives.</p>

            <div className='testimonal_box'>
                <div className='test_col'>
                  <a href='https://www.instagram.com/bhavna555/'><img src={Testiimg1}></img><img src={Playbtn} className='playbrnmbr'></img></a>
                  
                  {/* <h5>“Instant confidence boost. Exactly what I needed.”</h5>
                  <span>— Ananya</span> */}
                </div>
                <div className='test_col'>
                   <a href='https://www.instagram.com/bhavna555/'><img src={Testiimg2}></img><img src={Playbtn} className='playbrnmbr'></img></a>
                </div>
                <div className='test_col'>
                  <a href='https://www.instagram.com/bhavna555/'><img src={Testiimg3}></img><img src={Playbtn} className='playbrnmbr'></img></a>
                </div>
                <div className='test_col'>
                   <a href='https://www.instagram.com/bhavna555/'><img src={Testiimg4}></img><img src={Playbtn} className='playbrnmbr'></img></a>
                </div>
            </div>
             <a href="/about-us" className="terrs_btn test_btn">
                <img src={iconstrt} alt="" />
                VIEW ALL 
              </a>
              
        </div>
    </section>
    

    
   
   
   

</>



  );
};

export default HomePage;
